import { GeneralPath, INode, NodeStyleBase } from '@ardoq/yfiles';
import {
  MODERNIZED_BLOCK_DIAGRAM_CONTEXT_HIGHLIGHT_GAP as CONTEXT_HIGHLIGHT_GAP,
  MODERNIZED_BLOCK_DIAGRAM_CONTEXT_HIGHLIGHT_STROKE as CONTEXT_HIGHLIGHT_STROKE,
} from './consts';
import { hasContextAttributes } from '@ardoq/graph';

abstract class ModernizedNodeStyleBase extends NodeStyleBase {
  protected constructor() {
    super();
  }
  protected override getOutline(node: INode): GeneralPath | null {
    const graphItem = node.tag;

    const isContext =
      hasContextAttributes(graphItem) && graphItem.getIsContext();
    if (!isContext) {
      return super.getOutline(node);
    }
    const result = new GeneralPath(1);
    result.appendRectangle(
      node.layout
        .toRect()
        .getEnlarged(CONTEXT_HIGHLIGHT_GAP + CONTEXT_HIGHLIGHT_STROKE),
      false
    );
    return result;
  }
}
export { ModernizedNodeStyleBase };
